import React, { useState, useEffect } from 'react'
import { Card, CardBody, CardHeader } from '../../../../_metronic/_partials/controls'
import {
  Button,
  TextField,
  MuiThemeProvider,
  createMuiTheme
} from '@material-ui/core'
import { useHistory, useParams } from 'react-router-dom'
import { deleteUser, getUserById, postUser, updateUser } from '../../../../api/user'
import { useSkeleton } from '../../../hooks/useSkeleton'
import { alertError, alertSuccess } from '../../../../utils/logger'
import ConfirmDialog from '../../../components/dialogs/ConfirmDialog'

// Create theme for delete button (red)
const theme = createMuiTheme({
  palette: {
    secondary: {
      main: '#F64E60'
    }
  }
})

function getEmptyUser() {
  return {
    fullName: '',
    email: '',
    role: 'user',
    password: '',
    repeatPassword: ''
  }
}

export default function EditUsersPage() {
  const [user, setUser] = useState(getEmptyUser())
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false)
  const [newPassword, setNewPassword] = useState({ password: null, repeatPassword: null })
	const [changePassword, setChangePassword] = useState(false)
  const userId = useParams().id
  const history = useHistory()

  const { isLoading: isLoadingData, disableLoading: disableLoadingData, ContentSkeleton } = useSkeleton()

  useEffect(() => {
    if (!userId) {
      disableLoadingData()
      return
    }
    getUserById(userId).then(res => {
      if (res.status === 200) {
        const user = res.data
        delete user.password
        setUser(user)
        disableLoadingData()
      }
    }).catch(error => {
      alertError({ error: error, customMessage: 'No se ha podido obtener el usuario.' })
      history.push('/users')
    })
  }, [userId, disableLoadingData, history])

  function saveUser() {
		let saveUser = user
		if (!userId || changePassword) {
		  if (!newPassword.password || !newPassword.repeatPassword) {
			alertError({ error: null, customMessage: 'Por favor, ingrese una contraseña.' })
			return
		  }
		  if (newPassword.password !== newPassword.repeatPassword) {
			alertError({ error: null, customMessage: 'Las contraseñas no coinciden.' })
			return
		  }
		  saveUser = {...saveUser, password: newPassword.password }
		}
    if (!userId) {
      postUser(saveUser).then(res => {
        if (res.status === 201) {
          alertSuccess({ title: '¡Guardado!', customMessage: 'Usuario creado correctamente.' })
          history.push('/users')
        }
      }).catch(error => {
        alertError({ error: error, customMessage: 'No se ha podido guardar el usuario.' })
      })
    } else {
      updateUser(userId, saveUser).then(res => {
        if (res.status === 200) {
          alertSuccess({ title: '¡Guardado!', customMessage: 'Los cambios se han guardado correctamente.' })
          history.push('/users')
        }
      }).catch(error => {
        alertError({ error: error, customMessage: 'No se han podido guardar los cambios.' })
      })
    }
  }

  const handleChange = (element) => (event) => {
    setUser({ ...user, [element]: event.target.value })
  }

  if (isLoadingData)
    return <ContentSkeleton />
  else return (
    <>
      <Card>
        <CardHeader title='Editar usuario'>
        </CardHeader>
        <CardBody>
          <TextField
            id={`fullName`}
            label="Nombre"
            value={user.fullName}
            onChange={handleChange('fullName')}
            InputLabelProps={{
              shrink: true
            }}
            margin="normal"
            variant="outlined"
            required
          />
          <TextField
            id={`email`}
            label="Email"
            value={user.email}
            onChange={handleChange('email')}
            InputLabelProps={{
              shrink: true
            }}
            margin="normal"
            variant="outlined"
            required
          />
						{(!userId || changePassword) ? <>
							<br />
							<br />
							<TextField
								id={`password`}
								label="Contraseña"
								value={newPassword.password}
								onChange={(event) => {
									if (event.target.value !== ' ') setNewPassword({ ...newPassword, password: event.target.value })
								}}
								InputLabelProps={{
									shrink: true
								}}
								type="password"
								margin="normal"
								variant="outlined"
								required
							/>
							<TextField
								id={`repeatPassword`}
								label="Repetir contraseña"
								value={newPassword.repeatPassword}
								onChange={(event) => {
									if (event.target.value !== ' ') setNewPassword({ ...newPassword, repeatPassword: event.target.value })
								}}
								InputLabelProps={{
									shrink: true
								}}
								type="password"
								margin="normal"
								variant="outlined"
								required
							/>
							<br/>
							<br/>
							{userId && <>
								<Button
									onClick={() => {
										setChangePassword(false)
										setNewPassword({ password: null, repeatPassword: null })
									}}
									variant="outlined"
									style={{ marginRight: '20px' }}
								>
									Cancelar cambio de contraseña
								</Button>
								<br />
								<br />  
							</>}
							</> : <>
							<br />
							<br />
							<Button
								onClick={() => setChangePassword(true)}
								variant="outlined"
								color="primary"
								style={{ marginRight: '20px' }}
							>
								Cambiar contraseña
							</Button>
							<br />
							<br />
						</>}
						<br/>
        </CardBody>
      </Card>
      <Button
        onClick={() => history.push('/users')}
        variant="outlined"
        style={{ marginRight: '20px' }}>
        Atrás
      </Button>
      <Button
        onClick={() => saveUser()}
        variant="outlined"
        color="primary"
        style={{ marginRight: '20px' }}>
        Guardar usuario
      </Button>
      {userId && <>
        <MuiThemeProvider theme={theme}>
          <Button
            onClick={() => setOpenConfirmDialog(true)}
            variant="outlined"
            color="secondary">
        Eliminar usuario
          </Button>
        </MuiThemeProvider>

        <ConfirmDialog
          title={'¿Estás seguro de que quieres eliminar este usuario?'}
          open={openConfirmDialog}
          setOpen={setOpenConfirmDialog}
          onConfirm={() => {
            deleteUser(userId).then(res => {
              if (res.status === 204 || res.status === 200) {
                alertSuccess({ title: '¡Eliminado!', customMessage: 'Usuario eliminado correctamente' })
                history.push('/users')
              }
            }).catch(error => {
              alertError({ error: error, customMessage: 'No se ha podido eliminar el usuario.' })
            })
          }}
        />
      </>}
    </>
  );
}
